import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClientNotificationService } from '../data/client-nfs.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ClientNotification } from '../data/client-nfs';
import { PdfPreviewDialogComponent } from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import { NfsEmailsDialogComponent } from './nfs-emails-dialog/nfs-emails-dialog.component';

@Component({
    selector: 'app-client-send-email-dialog',
    templateUrl: './client-send-email-dialog.component.html',
    styleUrls: ['./client-send-email-dialog.component.scss'],
    providers: [DeviceDetectorService]
})
export class ClientSendEmailDialogComponent implements OnInit {

    dialogHeader: string;
    link: string;

    showSendButton = true;

    textAreaMessage: string;

    submitLoading: boolean;

    showLoadingSpinner: boolean;

    canBeEdited: boolean;

    isMobile: boolean;

    clientNf: ClientNotification;

    constructor(
        private snackBar: MatSnackBar,
        private clientNotificationService: ClientNotificationService,
        protected deviceDetectorService: DeviceDetectorService,
        protected dialog: MatDialog,
        protected dialogRef: MatDialogRef<ClientSendEmailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: {
            clientNfs: ClientNotification,
            dialogHeader: string,
            showSendButton: boolean,
            resolved: boolean;
        }
    ) {
        this.dialogHeader = data.dialogHeader;
        this.clientNf = data.clientNfs;
        this.showSendButton = data.showSendButton
        this.canBeEdited = !data.resolved
    }

    ngOnInit() {
        this.showLoadingSpinner = true;
        if (this.clientNf.clientMsg) {
            this.textAreaMessage = this.clientNf.clientMsg
            this.showLoadingSpinner = false;
        }
        else {
            this.clientNotificationService.getClientNfsEmail(this.clientNf.id).subscribe(msg => {
                this.textAreaMessage = msg.text
                this.showLoadingSpinner = false;
            })
        }


        this.isMobile = this.deviceDetectorService.isMobile();
    }

    sendEmail() {

        const cpDialogRef = this.dialog.open(NfsEmailsDialogComponent, {
            data: {
                clientNf: this.clientNf,
                textAreaMessage: this.textAreaMessage
            },
            panelClass: 'nfs-emails-dialog'
        });
        cpDialogRef.afterClosed().subscribe(result => {
            if (result === 'Success!') {
                this.dialogRef.close('Success!');
            }
        });
    }

    openPdfReport() {
        let link = `/project/${this.clientNf.project.id}/packing-slip-report`;
        let dialogHeader = `${this.clientNf.project.name} Packing Slip Report`

        if (this.clientNf.condition && this.clientNf.condition.name === 'passedQualityControl') {
            link = `/project/${this.clientNf.project.id}/qc-report`;
            dialogHeader = `${this.clientNf.project.name} QC Report`
        }

        const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
            data: {
                dialogHeader,
                link,
                showSendButton: false
            },
            panelClass: 'pdf-preview-dialog'
        });
    }

    openSnackBar(message: string, type: string) {
        let panelClass = 'client-snackbar';

        if (type === 'Error!') {
            panelClass = 'error-snackbar'
        }

        this.snackBar.open(message, '', {
            duration: 5000,
            panelClass,
            verticalPosition: 'top',
        });
    }

    closeDialog() {
        this.dialogRef.close('close-button');
    }

    autuGrow(element) {
        element.style.height = '5px';
        element.style.height = (element.scrollHeight) + 'px';
    }
}
